module.exports = __webpack_public_path__ + "img/07-lg.f04fda7.webp";